<template>
  <div>
    <ManutencaoModal />
    <EmManutencaoModal @status-manutencao="tratarStatusManutencao" />
    <b-row style="margin: 0; padding: 0" v-if="!estaEmManutencao">
      <b-col lg="6">
        <div class="card-portal">
          <div class="card-portal-title">
            <div>Desejamos boas-vindas</div>
            <div>ao Portal de laudos</div>
          </div>
          <div class="card-portal-text">
            <p>
              Insira os dados de protocolo e senha que você recebeu no
              atendimento.
            </p>
            <p class="info-result-exams" v-if="false">
              Para acessar o resultado dos seus exames, enviaremos um código de
              acesso para o e-mail ou celular informado no ato da realização do
              seu exame.
            </p>
          </div>
          <div class="card-portal-message-ds">
            <ImportantMessage />
          </div>
        </div>
      </b-col>
      <b-col lg="6">
        <div class="card-login" v-if="isVisibleLogin">
          <b-form type="submit" class="login-form" @submit.prevent="onSubmit">
            <b-form-group
              id="input-group-1"
              label="Protocolo"
              label-for="protocolo"
              style="font-weight: bold; margin-top: 0"
              class="login-group"
            >
              <b-form-input
                id="protocolo"
                type="text"
                placeholder="Insira o seu protocolo ou usuário"
                required
                maxLength="13"
                v-model="serviceIdentifier.number"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-1"
              label="Senha"
              label-for="senha"
              style="font-weight: bold"
              class="login-group"
            >
              <b-form-input
                id="senha"
                type="password"
                placeholder="Insira a senha"
                v-model="serviceIdentifier.password"
                maxLength="20"
                required
              ></b-form-input>
            </b-form-group>
            <div v-if="validationAuthErro" class="invalid">
              {{ validationAuthErro }}
            </div>
            <b-button
              type="submit"
              class="login-button"
              variant="success"
              :disabled="isDisableButton"
            >
              <b-spinner small v-if="isLoading"></b-spinner>
              Entrar</b-button
            >
          </b-form>
        </div>
        <div class="card-security-code" v-else>
          <div class="card-security-code__content">
            <b-form type="submit" v-if="isVisibleUserContact">
              <div class="acesso-form__titulo">
                Olá,<br />
                Você receberá um código de segurança para prosseguir com o
                acesso ao(s) seu(s) Exame(s).
              </div>
              <div class="acesso-form__text">
                Confira abaixo e selecione a opção desejada.
              </div>
              <div>
                <a class="send-security-code" @click="sendSecurityCode">
                  <div
                    class="send-security-code__contact-method"
                    v-if="isVisibleEmail"
                  >
                    <img src="../assets/imagens/icon-email.svg" />
                    <div class="contact-info">
                      {{ userContact.emailMask }}
                    </div>
                  </div>
                  <div
                    class="send-security-code__contact-method"
                    style=""
                    v-else
                  >
                    <img src="../assets/imagens/icon-email.svg" />
                    <div class="contact-info">
                      {{ userContact.phoneMask }}
                    </div>
                  </div>
                  <div>
                    <b-spinner
                      v-if="isLoading"
                      class="spinner-color spinner"
                    ></b-spinner>
                    <img
                      v-else
                      src="../assets/imagens/icon-arrow-right.svg"
                      alt="Enviar código por e-mail."
                    />
                  </div>
                </a>
              </div>
            </b-form>
            <ErrorMessage :isError="isError" :errorMessage="errorMessage" />
            <div v-if="isVisibleSecurityCode" class="security-code">
              <div class="security-code__title">
                Informe o código recebido por {{ contactMethod }}.
              </div>
              <div
                class="security-code__inputs-container"
                style="margin-top: 38px"
              >
                <div class="security-code__inputs">
                  <input
                    v-for="(d, index) in 6"
                    :key="index"
                    type="text"
                    maxlength="1"
                    class="code-digit"
                    :class="{ 'security-code__digit--error': isError }"
                    v-model="codeInputs[index]"
                    :ref="'input'"
                    @input="moveToNextField(index)"
                    :disabled="remainingTime === 0"
                  />
                </div>
              </div>
              <div class="timer-container" v-if="isVisibleTimer">
                <div class="spinner-timer">
                  <b-spinner class="spinner-color spinner"></b-spinner>
                  <span class="timer">{{ formatarTime(remainingTime) }}</span>
                </div>
              </div>
              <div class="message-resend-code" v-else-if="isResendCode">
                <div>
                  <a @click="resendCode">Reenviar o código de segurança</a>
                </div>
              </div>
              <div class="invalid text-center" v-if="isCodeInvalid">
                <div class="code-invalid">Código inválido</div>
                <div>
                  {{ codeValidationTries }} tentativa(s) feita(s). Após 3, será
                  redirecionado.
                </div>
              </div>
            </div>
          </div>
          <div class="legend-info">
            <div>
              <img
                v-if="isResendCode || isVisibleUserContact"
                src="../assets/imagens/icon-info-24px.svg"
                class="legend-info__icon"
                alt="Caso você tenha acesso ou deseja alterar os contatos listados,
              acesse a opção Atualizar dados para acesso."
              />
              <img
                v-else
                src="../assets/imagens/icon-info-24px-mutted.svg"
                class="legend-info__icon"
                alt="Caso você tenha acesso ou deseja alterar os contatos listados,
              acesse a opção Atualizar dados para acesso."
              />
            </div>
            <div
              :class="{
                'legend-info__text--enabled': true,
                'legend-info__text--disabled':
                  !isResendCode && isVisibleSecurityCode,
              }"
            >
              Para receber o código de segurança por
              {{ alternateContactMethod }},
              <a
                @click="toggleContactMethod"
                :class="{
                  'link-enabled': isResendCode || isVisibleUserContact,
                  'link-disabled': !isResendCode && isVisibleSecurityCode,
                }"
              >
                clique aqui</a
              >
            </div>
          </div>
        </div>
        <div class="card-portal-message-mb">
          <ImportantMessage />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ErrorMessage from "../components/Message/ErrorMessage.vue";
import ManutencaoModal from "../components/ManutencaoModal.vue";
import EmManutencaoModal from "../components/EmManutencaoModal.vue";

import qs from "qs";
import ImportantMessage from "../components/Message/ImportantMessage";
import provedor from "../http/provedor";
import {
  getUserContactAync,
  sendSecurityCodeAsync,
  validateSecurityCodeAsync,
  authenticate,
} from "../services/authService";

const MAX_CODE_VALIDATIONN_TRIES = 3;
const INITIAL_REMAINING_TIME = 120; // 120 - 2 minutos em segundos

export default {
  data() {
    return {
      isEmailChosen: true,
      isLoading: false,
      isInvalid: false,
      isError: false,
      isVisibleEmail: true,
      isVisibleLogin: true,
      isVisibleUserContact: false,
      isVisibleSecurityCode: false,
      isVisibleTimer: false,
      isResendCode: false,
      isDisableButton: false,
      isCodeInvalid: false,
      desabilitar: false,
      validationAuthErro: null,
      errorMessage: "",
      remainingTime: INITIAL_REMAINING_TIME,
      interval: null,
      codeValidationTries: 0,
      serviceIdentifier: {
        number: "",
        password: "",
      },
      userContact: {
        email: null,
        emailMask: null,
        phone: null,
        phoneMask: null,
      },
      codeInputs: Array(6).fill(""),
      estaEmManutencao: false,
    };
  },
  components: {
    ImportantMessage,
    ErrorMessage,
    ManutencaoModal,
    EmManutencaoModal,
  },
  async created() {
    provedor.dispatch("autenticar");
  },
  methods: {
    tratarStatusManutencao(status) {
      this.estaEmManutencao = status;
    },
    async onSubmit() {
      this.isLoading = true;

      const isSucessfull = authenticate(
        this.serviceIdentifier.number,
        this.serviceIdentifier.password,
      );

      if (isSucessfull) {
        this.$router.push({
          name: "ListaExames",
          params: {
            protocolo: this.serviceIdentifier.number,
            senha: this.serviceIdentifier.password,
          },
        });
      } else {
        if (erro.response.status == 404) {
          this.mensagemErro =
            "Número de protocolo, usuário ou senha inválidos.";
        } else {
          this.mensagemErro = "Erro no servidor, tente mais tarde.";
        }

        this.isLoading = false;
        this.serviceIdentifier.number = "";
        this.serviceIdentifier.password = "";
      }
    },
    async searchContactAndShow() {
      this.isLoading = true;
      this.isDisableButton = true;
      this.validationAuthErro = null;

      try {
        this.userContact = await getUserContactAync(
          this.serviceIdentifier.number,
          this.serviceIdentifier.password,
        );
        this.displayUserContact();
      } catch (error) {
        this.validationAuthErro = error.message;
        this.clearLoginCard();
      } finally {
        this.isLoading = false;
      }
    },
    displayUserContact() {
      this.isVisibleUserContact = true;

      this.isVisibleLogin = false;
      this.isVisibleSecurityCode = false;
    },
    toggleContactMethod() {
      this.isVisibleEmail = !this.isVisibleEmail;
      this.isError = false;
      this.displayUserContact();
    },
    clearLoginCard() {
      this.serviceIdentifier.number = null;
      this.serviceIdentifier.password = null;
      this.isDisableButton = false;
    },
    async resendCode() {
      this.remainingTime = INITIAL_REMAINING_TIME;
      await this.sendSecurityCode();
    },
    async sendSecurityCode() {
      const contactMethod = this.isVisibleEmail ? "E" : "S";
      const destination = this.isVisibleEmail
        ? this.userContact.email
        : this.userContact.phone;

      this.isLoading = true;

      try {
        await sendSecurityCodeAsync(
          contactMethod,
          this.serviceIdentifier.number,
          destination,
        );
        this.displayCodeValidation();
      } catch (error) {
        this.isError = true;
        this.errorMessage = error.message;
      } finally {
        this.isLoading = false;
      }
    },
    displayCodeValidation() {
      this.isVisibleUserContact = false;
      this.isVisibleSecurityCode = true;

      this.startTimer();
    },
    startTimer() {
      this.isVisibleTimer = true;

      this.interval = setInterval(() => {
        if (this.remainingTime > 0) {
          this.remainingTime--;
        } else {
          this.displayResendCode();
          clearInterval(this.interval);
        }
      }, 1000);
    },
    displayResendCode() {
      this.isVisibleTimer = false;
      this.isResendCode = true;
      this.isError = false;
      this.isCodeInvalid = false;
    },
    async validateCodeInputs() {
      const codeInputs = this.codeInputs.join("");

      try {
        const isOk = await validateSecurityCodeAsync(
          codeInputs,
          this.serviceIdentifier.number,
        );

        if (isOk) {
          this.$store.commit("USUARIO_LOGADO", { protocolo: this.protocolo });

          this.$router.push({
            name: "ListaExames",
            params: {
              protocolo: this.serviceIdentifier.number,
              senha: this.serviceIdentifier.password,
            },
          });
        } else {
          this.handleInvalidCode();
        }
      } catch (error) {
        alert(error);
      }
    },
    handleInvalidCode() {
      if (this.codeValidationTries < MAX_CODE_VALIDATIONN_TRIES) {
        this.displayInvalidCode();
      } else {
        location.reload();
      }
    },
    resetPage() {
      location.reload();
    },
    displayInvalidCode() {
      this.isCodeInvalid = true;
      this.codeValidationTries++;

      this.clearCodeInputs();
      this.markCodeInputsAsInvalid();
    },
    clearCodeInputs() {
      this.codeInputs = Array(6).fill("");
    },
    markCodeInputsAsInvalid() {
      this.$nextTick(() => {
        const inputs = this.$refs.input;
        inputs.forEach((input) => {
          input.classList.add("input-error");
        });
      });
    },
    formatarTime(seconds) {
      const minutes = Math.floor(seconds / 60);
      const secs = seconds % 60;
      return `${String(minutes).padStart(2, "0")}:${String(secs).padStart(
        2,
        "0",
      )}`;
    },
    async moveToNextField(index) {
      if (this.codeInputs[index] && this.codeInputs[index].length === 1) {
        this.$nextTick(() => {
          const inputs = this.$refs.input;

          if (inputs[index + 1]) {
            inputs[index + 1].focus();
            inputs[index + 1].select();
          }

          if (this.allInputsFilled()) {
            this.validateCodeInputs();
          }
        });
      }
    },
    allInputsFilled() {
      return this.codeInputs.every((digit) => digit.length === 1);
    },
    getContactMethod(isEmail) {
      return isEmail ? "e-mail" : "SMS";
    },
  },
  computed: {
    contactMethod() {
      return this.getContactMethod(this.isVisibleEmail);
    },
    alternateContactMethod() {
      return this.getContactMethod(!this.isVisibleEmail);
    },
  },
  beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  },
};
</script>

<style scoped>
.security-code__digit--error {
  border: 1px solid #dc3545 !important;
}

.message-resend-code {
  text-align: center;
  font-size: 14px;
  text-decoration: underline;
}

.message-resend-code a {
  text-decoration: underline;
  text-decoration-color: initial;
}

.message-resend-code a:hover {
  color: #6c757d !important;
  cursor: pointer;
  text-decoration-color: #6c757d;
}

.spinner {
  width: 20px !important;
  height: 20px !important;
}

.spinner-color {
  color: #8bc34a;
}

.spinner-timer {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  gap: 0.5rem;
}

.spinner-border {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  vertical-align: -0.125em;
  border: 2px solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  -webkit-animation: 0.75s linear infinite spinner-border;
  animation: 0.75s linear infinite spinner-border;
}

.security-code__inputs input[type="text"] {
  margin-right: 15px;
}

.code-digit {
  width: 36px;
  height: 50px;
  font-size: 24px;
  text-align: center;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.security-code__inputs-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2.5rem;
  margin-bottom: 16px;
}

.send-security-code {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: #1f1f1f;
  font-weight: 500;
  padding: 10px 16px;
  border: 1px solid #d0d7de;
  border-radius: 6px;
  white-space: nowrap;
  overflow: hidden;
  text-decoration: none;
}

.send-security-code__contact-method {
  display: flex;
  align-items: center;
  column-gap: 8px;
}

.inline-block {
  display: inline-block;
  margin-right: 8px;
}

.contact-info {
  width: 284px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.legend-info {
  font-size: 12px;
  font-weight: 500;
  display: flex;
  justify-content: flex-start;
  align-items: baseline;
}

.legend-info__icon {
  margin-right: 8px;
}

.legend-info a:hover {
  color: #32a97e;
  cursor: pointer;
}

.legend-info__text--enabled {
  color: #161d28;
}

.legend-info__text--disabled {
  color: #c2cddd;
}

.link-enabled {
  font-weight: bold;
  color: #0d6efd !important;
  text-decoration: underline !important;
}

.link-disabled {
  color: #c2cddd;
  cursor: not-allowed;
  text-decoration: none;
}

.send-security-code:hover {
  background-color: #d8dee4;
}

.acesso-form__titulo {
  font-size: 16px;
  font-weight: bold;
  padding-bottom: 8px;
  border-bottom: 2px solid transparent;
  border-image: linear-gradient(to right, #b1d34b 40px, white 0) 1;
  text-align: left;
}

.security-code__title {
  font-size: 16px;
  font-weight: bold;
  padding-bottom: 8px;
  border-bottom: 2px solid transparent;
  border-image: linear-gradient(to right, #b1d34b 40px, white 0) 1;
  text-align: left;
}

.acesso-form__text {
  margin-top: 8px;
  margin-bottom: 32px;
  font-size: 14px;
  color: #9ea3bb;
}

/* FIM */
.card-portal-title {
  color: #00995d;
  font-weight: bold;
  padding: 0 0 0 0;
}

.card-portal-text {
  font-weight: 600;
}

.card-login,
.card-security-code {
  background: #ffffff;
  border-radius: 10px;
}

.card-security-code__content {
  height: 254px;
}

.btn-success.login-button {
  height: 40px;
  margin: 5px 0 15px;
  background-color: #28a745;
  border: 1px solid #1ecb40;
}

.invalid {
  color: #dc3545;
  font-size: 14px;
}

.code-invalid {
  font-size: 16px;
  font-weight: bold;
  margin-top: 16px;
}

.info-result-exams {
  font-weight: 400;
  padding-top: 8px;
}

@media (min-width: 320px) {
  .card-portal {
    width: 320px;
    margin: 25px auto;
  }

  .card-portal-title {
    font-size: 24px;
    margin: 25px 0;
  }

  .card-portal-message-ds {
    display: none;
  }

  .card-login,
  .card-security-code {
    margin: auto;
    padding: 40px 30px;
  }

  .card-login div {
    margin: 25px 0;
  }

  .card-portal-message-mb {
    display: block;
    margin-top: 25px;
  }

  .btn-success.login-button {
    width: 100%;
  }
}

@media (min-width: 576px) {
  .card-portal,
  .card-portal-message-mb {
    width: 420px;
    margin: 25px auto;
  }

  .card-login,
  .card-security-code {
    width: 430px;
    margin: 30px auto;
    padding: 60px;
  }
}

@media (min-width: 992px) {
  .card-portal {
    margin-top: 170px;
    margin-right: 15px;
    float: right;
  }

  .card-portal-title {
    font-size: 30px;
  }

  .card-portal-message-ds {
    display: block;
    margin-top: 60px;
  }

  .card-login,
  .card-security-code {
    margin-top: 180px;
    margin-left: 0;
    width: 508px;
    height: 374px;
  }

  .btn-success.login-button {
    width: 120px;
  }

  .card-portal-message-mb {
    display: none;
  }
}
</style>
